<template>
  <div class="claim-page common-bg">
    <van-nav-bar fixed title="担保与理赔" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>

    <div class="claim-tabs">
      <div class="claim-tab" :class="{ active: activeTab === 0 }" @click="activeTab = 0">理赔申请</div>
      <div class="claim-tab" :class="{ active: activeTab === 1 }" @click="activeTab = 1">理赔订单</div>
      <div class="claim-tab" :class="{ active: activeTab === 2 }" @click="activeTab = 2">担保与理赔规则</div>
    </div>

    <!-- 理赔申请 -->
    <div class="claim-content claim-content-scroll" v-if="activeTab === 0">
      <div class="rules-text" v-html="rulesHtml"></div>
    </div>
    <div class="claim-bottom-bar" v-if="activeTab === 0">
      <div class="claim-agree">
        <div class="claim-checkbox" :class="{ checked: agreed }" @click="agreed = !agreed">
          <van-icon v-if="agreed" name="success" color="#fff" size="16" />
        </div>
        <span class="claim-agree-text">已阅读并同意 <span class="claim-agree-link" @click="activeTab = 2">《理赔规则》</span>，且不存在恶意申请。</span>
      </div>
      <div class="claim-submit-btn" :class="{ disabled: countdown > 0 }" @click="handleSubmit">
        {{ countdown > 0 ? `请详细阅读规则后申请 (${countdown}s)` : '申请理赔' }}
      </div>
    </div>

    <!-- 理赔订单 -->
    <div class="claim-content" v-if="activeTab === 1">
      <div class="claim-empty">
        <div class="claim-empty-icon">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 35L40 25L60 35V55L40 65L20 55V35Z" fill="#333"/>
            <path d="M20 35L40 45L60 35" stroke="#555" stroke-width="2"/>
            <path d="M40 45V65" stroke="#555" stroke-width="2"/>
            <path d="M45 15L55 10L50 20L45 15Z" fill="#555"/>
          </svg>
        </div>
        <div class="claim-empty-text">暂无内容 <span class="claim-loading"></span></div>
      </div>
    </div>

    <!-- 担保与理赔规则 -->
    <div class="claim-content" v-if="activeTab === 2">
      <div class="rules-text" v-html="rulesHtml"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'claim',
  data() {
    return {
      activeTab: 0,
      agreed: false,
      countdown: 44,
      timer: null,
      rulesHtml: `<p style="text-align: center;"><strong class="title">全方位保障服务规则</strong></p>
<p style="line-height: 1.6;"><span style="font-size: 14px;"><span style="color: #999;"><span style="color: #333333;"><strong class="title">1. 担保规则</strong></span><br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （1）保障说明：</strong></span>本网站由第三方担保机构"NO钱包"进行<span style="color: #333333;"><strong class="title">全方位保障</strong></span>，已向NO钱包缴纳50,000,000.00 USDT（等值美元）保证金；<span style="color: #333333;"><strong class="title">网址是理赔的唯一依据！</strong></span>使用前请先验证网址的真实性，未来才能放心地使用或发起理赔；<span style="color: #333333;"><strong class="title">验证网址只能到NO钱包的官网<span style="color: #1678ff;"><a style="color: #1678ff;" href="http://www.no.com/">no.com</a></span>上查验。</strong></span><br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （2）请勿随意发起申请：</strong></span>理赔是最后一道保障措施，若您遇到纠纷时请先与平台客服协商解决，协商无果后才能申请理赔。<br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp;&nbsp;&nbsp;&nbsp;（3）恶意申请处罚规则：</strong></span>若非正当理由或不符合条件，但仍恶意发起申请的，请自行主动操作取消，否则理赔失败将被视为恶意申请，首次失败将暂停理赔功能7天，连续两次失败将被永久禁用理赔功能。<br><br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">2. 支持的理赔类型：</strong></span>全方位保障支持以下六种情形的理赔类型。<br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （1）被判定违规，申请退还本金理赔：</strong></span>若您唯一的个人账号内有资产余额，且已完成投注任务，只要该账号累计充值大于累计提现（即充提差额＞0），无论是否盈利，被平台判定为非专业性的违规行为（含账号被冻结或被列入黑名单，提现被拒绝或提现不被受理等情形），则您才可以申请退还本金的理赔（即索赔充提差额部分）；<span style="color: #333333;"><strong class="title">若被风控系统识别为"一机多号、团伙性套利、恶意代码或专业刷客"等专业性违规，则该账号的理赔将不被受理。</strong></span>要求理赔金额≤充提差额且≤当前余额，且近30天有提现被拒绝或被强制取消记录、存在人工扣款记录、账号被冻结或列入黑名单、被禁止进入游戏、被禁止提现等其中的任意一项才能发起申请。理赔提交后将从该账户当前余额扣除相应的理赔金额，申请理赔成功后，将收取理赔金额0-25%的手续费作为第三方支付和第三方游戏成本。<br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title"><strong class="title">&nbsp; &nbsp; 举例说明：</strong></strong><span style="color: #999;">假设A会员累计充值1000，已经累计提现300（充提差额=1000-300=700），若A当前账户余额500，则A可以申请理赔500，理赔成功后实际到账为500-500*15%=425；若A当前账户余额1500，则A最多只能申请理赔700，理赔成功后实际到账为700-700*15%=595。</span><strong class="title"><strong class="title"><br>&nbsp; &nbsp; </strong>（2）<strong class="title">虚假人工出款理赔：</strong></strong><span style="color: #999;">若您在近30天内提现记录中，若有超过72小时未到账或被人工标记为强制出款的订单，且当前账号没有投注任务要求（即已完成所有投注任务），能证明当前的收款资料准确无误（例如：账号历史至少有一次提现成功的记录，或提交银行资料截图等能证明当前收款资料准确无误的图片）；您应先与平台客服友好协商，协商后仍被拒绝的才能提交理赔申请，且申请的理赔金额小于等于该笔提现金额。理赔成功后，账号正常使用；若理赔失败，判定为恶意理赔，首次暂停理赔功能7天，连续两次则永久暂停理赔功能。</span></span></span><br><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （3）被人工异常扣款理赔：</strong></span>若您在近30天内，存在被人工异常扣款，且该账号未触发风控行为，您应先与平台客服友好协商，协商后仍被拒绝的才能申请此类型的理赔。理赔时必须选择关联人工扣款记录，要求理赔金额只能等于该笔人工扣款金额。<br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （4）大额提现被拒理赔（仅限高级保障及全方位保障商户）：</strong></span>若您在近30天内，存在提现被拒绝或强制取消，且该账号未触发风控行为，并且当前无投注任务、充值任务和提现任务，您应先与平台客服友好协商，协商后仍被拒绝的才能申请此类型的理赔。理赔时必须选择关联被拒绝的提现订单，要求理赔金额只能等于该笔提现订单的金额。<br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （5）账号资金被盗理赔（仅限全方位保障商户，且不支持数字货币和三方电子钱包出款）：</strong></span>若您账号已经同时设置提现密码、开启提现两步验证（即绑定手机、邮箱或Google验证器）和绑定真实姓名，在近30天内，存在非本人实名的提现订单（即收款人不是本人实名），被判定为资金被盗情形的（即技术原因导致的资产被盗），且仅限于该账号属于法定货币币种（即不含属于匿名的虚拟货币和三方电子钱包），您应先与平台客服友好协商，协商后仍被拒绝的才能申请此类型的理赔。理赔时必须选择关联非本人实名的提现订单，要求理赔金额只能等于该笔提现订单的金额。<br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp;&nbsp;&nbsp;&nbsp;（6）网站永久性关闭退还本金理赔（仅限全方位保障商户）：</strong></span>若该网站因经营不善或主动申请永久性关闭（不含迁移或合并的短暂性维护），则该网站应当主动退还所有用户的本金；若该网站已经关闭，则您可以在网站关闭后的30天内（逾期不再受理），到NO钱包官网申请此类型的理赔，要求理赔金额≤充提差额且≤当前余额，逾期不受理。<br><br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">3. 理赔入口和有效期</strong></span><br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （1）网站运营中：</strong></span>网站正常运营时，通过【我的】&gt;【第三方担保与理赔】入口申请，仅受理近30天内纠纷。<br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （2）网站已关闭：</strong></span>网站永久关闭后，方可前往NO钱包官网（<span style="color: #1678ff;"><a style="color: #1678ff;" href="http://www.no.com/">no.com</a></span>）申请理赔。<br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （3）30天有效期：</strong></span>纠纷发生后的30天内，逾期不受理；且担保生效前的纠纷也在受理范围。<br><br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">4. 理赔流程</strong></span><br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （1）前提条件：</strong></span>发生纠纷时，您应先与平台客服友好协商，协商后仍被拒绝的，才能提交理赔申请，否则可能被判定为恶意理赔。<br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （2）申请流程：</strong></span>用户提交申请后，由NO钱包理赔团队审查是否受理，因为理赔审核需要大量工作，所以一般需要1-15个工作日才能完成判定，实际时长将根据订单情况决定，期间您需积极配合提交申诉材料。<br><br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">5. 验证方式</strong></span><br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （1）如何验证：</strong><strong class="title">因为"网址是唯一的理赔依据"</strong></span>，所以充值前可以先到NO钱包官网（<span style="color: #1678ff;"><a style="color: #1678ff;" href="http://www.no.com/">no.com</a></span> 或 <span style="color: #1678ff;"><a style="color: #1678ff;" href="http://www.no.com/">www.no.com</a></span>）查询当前网址是否在担保范围内。<br></span><span style="color: #999;"><span style="color: #333333;"><strong class="title">&nbsp; &nbsp; （2）验证步骤：</strong></span>请务必手动输入NO钱包官网<span style="color: #1678ff;"><a style="color: #1678ff;" href="http://www.no.com/">no.com</a></span>，然后复制当前平台完整网址进行查验；请勿相信或点击可疑链接，以免遇到假的NO钱包。</span></span></p>`,
    };
  },
  created() {
    this.startCountdown();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    handleSubmit() {
      if (this.countdown > 0) return;
      if (!this.agreed) {
        this.$parent.showTost(0, '请先勾选"已阅读并同意《理赔规则》"');
        return;
      }
      this.$parent.showTost(1, '理赔申请已提交');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/common.css';

.claim-page {
  min-height: 100vh;
  background: #1a1a1a;
  padding-bottom: 4rem;

  .claim-content-scroll {
    padding-bottom: 4rem;
  }

  .claim-tabs {
    display: flex;
    background: #292A2C;
    padding: 0 0.3rem;

    .claim-tab {
      padding: 0.3rem 0.4rem;
      color: #999;
      font-size: 0.3rem;
      position: relative;
      cursor: pointer;

      &.active {
        color: #DFB372;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0.1rem;
          right: 0.1rem;
          height: 2px;
          background: #DFB372;
        }
      }
    }
  }

  .claim-bottom-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #1a1a1a;
    padding: 0.3rem;
    z-index: 100;

    .claim-agree {
      display: flex;
      align-items: flex-start;
      padding: 0.2rem 0;

      .claim-checkbox {
        width: 0.36rem;
        height: 0.36rem;
        border: 1.5px solid #666;
        border-radius: 0.06rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-right: 0.15rem;
        margin-top: 0.05rem;

        &.checked {
          border-color: #04BE02;
          background: #04BE02;
        }
      }

      .claim-agree-text {
        color: #fff;
        font-size: 0.28rem;
        line-height: 1.4;

        .claim-agree-link {
          color: #d1ae52;
        }
      }
    }

    .claim-submit-btn {
      background: #d1ae52;
      color: #703904;
      text-align: center;
      padding: 0.25rem;
      border-radius: 0.15rem;
      font-size: 0.3rem;
      margin-top: 0.3rem;
      cursor: pointer;
      border: 1px solid #d1ae52;

      &.disabled {
        background: #555;
        color: #999;
        border-color: #555;
      }
    }
  }

  .claim-content {
    padding: 0.3rem;

    .rules-title {
      text-align: center;
      color: #fff;
      font-size: 0.35rem;
      font-weight: bold;
      margin-bottom: 0.3rem;
    }

    .rules-text {
      color: #ccc;
      font-size: 0.28rem;
      line-height: 1.6;

      p {
        margin-bottom: 0.2rem;
      }

      a {
        color: #d1ae52;
      }
    }

    .claim-agree {
      display: flex;
      align-items: flex-start;
      margin-top: 0.4rem;
      padding: 0.2rem 0;

      .claim-checkbox {
        width: 0.36rem;
        height: 0.36rem;
        border: 1.5px solid #666;
        border-radius: 0.06rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-right: 0.15rem;
        margin-top: 0.05rem;

        &.checked {
          border-color: #04BE02;
          background: #04BE02;
        }
      }

      .claim-agree-text {
        color: #fff;
        font-size: 0.28rem;
        line-height: 1.4;

        .claim-agree-link {
          color: #d1ae52;
        }
      }
    }

    .claim-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 3rem 0;

      .claim-empty-icon {
        margin-bottom: 0.3rem;
      }

      .claim-empty-text {
        color: #666;
        font-size: 0.3rem;
        display: flex;
        align-items: center;

        .claim-loading {
          display: inline-block;
          width: 0.3rem;
          height: 0.3rem;
          border: 2px solid #333;
          border-top-color: #DFB372;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-left: 0.1rem;
        }
      }
    }
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>

<style lang="scss">
.claim-page .rules-text .title {
  color: #fff !important;
}
.claim-page .rules-text a {
  color: #d1ae52 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/claim.vue